module.exports = __webpack_public_path__ + "img/checkmark-circle-green.de9e3fe0.svg";